import {
  Address,
  getOracle,
  OracleKey,
  ProtocolKey,
  UNKNOWN_ORACLE,
} from "@silo/types";
import { cn } from "../../utils/class-names";
import { Pill } from "../pill";
import { match } from "ts-pattern";
import { TooltipDescription } from "../description";
import { OracleAssets } from "./types";
import { Description } from "./description";
import { Option, pipe } from "effect";
import { Indicator } from "./indicator";

export interface OraclePillProps {
  className?: string;
  oracleKey: OracleKey | null;
  oracleAssets: OracleAssets;
  symbols: string[];
  marketAddress: Address;
  marketName: string;
  marketSymbol: string;
  rawMarketSymbol: string;
  protocolKey: ProtocolKey;
}

export function OraclePill({
  className,
  oracleKey,
  oracleAssets,
  symbols,
  marketAddress,
  marketName,
  marketSymbol,
  rawMarketSymbol,
  protocolKey,
}: OraclePillProps): JSX.Element {
  const { label, riskLevel } = pipe(
    oracleKey,
    Option.fromNullable,
    Option.map(getOracle),
    Option.getOrElse(() => UNKNOWN_ORACLE)
  );

  return (
    <Pill className={cn("", className)}>
      <Indicator riskLevel={riskLevel} />

      <div>
        {symbols.join(", ")} oracle: {label}
      </div>

      {!!oracleKey && (
        <TooltipDescription placement="right-start">
          <Description
            oracleKey={oracleKey}
            oracleAssets={oracleAssets}
            marketAddress={marketAddress}
            marketName={marketName}
            marketSymbol={marketSymbol}
            protocolKey={protocolKey}
            rawMarketSymbol={rawMarketSymbol}
          />
        </TooltipDescription>
      )}
    </Pill>
  );
}
